<template>
  <div>
    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-start mb-1">
      <div>
        <h4 class="font-weight-bold">BDM Bonus Bets Analysis</h4>
        <div class="text-muted">
          Bonus bet performance by BDM segment over the last year
        </div>
      </div>

      <div>
        <b-button variant="primary" @click="handleExport" :disabled="loadingBdmBonusBets">
          <feather-icon icon="DownloadIcon" size="16" class="mr-1" />
          Export
        </b-button>
      </div>
    </div>

    <!-- SUMMARY STATS -->
    <b-card>
      <div>
        <b-row>
          <b-col cols="12" sm="6" md="3">
            <div class="stat-box">
              <div class="text-muted small">Total Bonuses Issued</div>
              <div class="h5 font-weight-bold">${{ totalBonusesIssued.toFixed(2) }}</div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <div class="stat-box">
              <div class="text-muted small">Bonus Bet Placements</div>
              <div class="h5 font-weight-bold">{{ totalBonusCount }}</div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <div class="stat-box">
              <div class="text-muted small">Total Bonus GGR</div>
              <div class="h5 font-weight-bold text-success">${{ totalBonusGgr.toFixed(2) }}</div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <div class="stat-box">
              <div class="text-muted small">Avg Margin %</div>
              <div class="h5 font-weight-bold">{{ avgMarginPct.toFixed(2) }}%</div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- TABLE -->
    <b-card no-body>
      <div class="m-2">
        <label>Showing {{ bdmBonusBets.length }} BDM segments</label>
      </div>

      <b-table
        :items="bdmBonusBets"
        :fields="tableFields"
        show-empty
        responsive
        :busy="loadingBdmBonusBets"
      >
        <template #cell(bdmTag)="{ item }">
          <b-badge variant="info">{{ item.bdmTag }}</b-badge>
        </template>

        <template #cell(bonusesIssued)="{ item }">
          <span class="font-weight-semibold">{{ formatCurrencyBuiltInFunc(item.bonusesIssued) }}</span>
        </template>

        <template #cell(bonusesIssuedCount)="{ item }">
          {{ item.bonusesIssuedCount }}
        </template>

        <template #cell(bonusGgr)="{ item }">
          <span class="font-weight-semibold text-success">{{ formatCurrencyBuiltInFunc(item.bonusGgr) }}</span>
        </template>

        <template #cell(bonusMarginPct)="{ item }">
          <b-badge
            :variant="item.bonusMarginPct > 0 ? 'success' : 'danger'"
          >
            {{ item.bonusMarginPct.toFixed(2) }}%
          </b-badge>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BButton, BTable, BBadge } from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
  },
  data() {
    return {
      tableFields: [
        { key: "bdmTag", label: "BDM Segment" },
        { key: "bonusesIssued", label: "Bonuses Issued" },
        { key: "bonusesIssuedCount", label: "Placements" },
        { key: "bonusGgr", label: "Bonus GGR" },
        { key: "bonusMarginPct", label: "Margin %" },
      ],
    };
  },
  computed: {
    ...mapState("reporting", ["bdmBonusBets", "loadingBdmBonusBets"]),
    totalBonusesIssued() {
      return (this.bdmBonusBets || []).reduce((sum, item) => sum + (item.bonusesIssued || 0), 0);
    },
    totalBonusCount() {
      return (this.bdmBonusBets || []).reduce((sum, item) => sum + (item.bonusesIssuedCount || 0), 0);
    },
    totalBonusGgr() {
      return (this.bdmBonusBets || []).reduce((sum, item) => sum + (item.bonusGgr || 0), 0);
    },
    avgMarginPct() {
      const data = this.bdmBonusBets || [];
      if (data.length === 0) return 0;
      const sum = data.reduce((acc, item) => acc + (item.bonusMarginPct || 0), 0);
      return sum / data.length;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions("reporting", ["getBdmBonusBets"]),
    async fetchData() {
      await this.getBdmBonusBets();
    },

    handleExport() {
      alert("Export functionality to be implemented");
    },
  },
};
</script>

<style scoped>
.stat-box {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}
</style>
